import { $t } from '@previo/core'
import { PDatePickerFastChoice, type PDatePickerFastChoiceItem } from './types'

export const dateFastChoicesList: PDatePickerFastChoiceItem[] = [
  {
    type: PDatePickerFastChoice.YESTERDAY,
    name: $t('Yesterday'),
  },
  {
    type: PDatePickerFastChoice.TODAY,
    name: $t('Today'),
  },
  {
    type: PDatePickerFastChoice.TOMORROW,
    name: $t('Tomorrow'),
  },
  {
    type: PDatePickerFastChoice.MONDAY_OF_LAST_WEEK,
    name: $t('Last Week'),
  },
  {
    type: PDatePickerFastChoice.MONDAY_OF_THIS_WEEK,
    name: $t('This Week'),
  },
  {
    type: PDatePickerFastChoice.MONDAY_OF_NEXT_WEEK,
    name: $t('Next Week'),
  },
  {
    type: PDatePickerFastChoice.FIRST_OF_LAST_MONTH,
    name: $t('Last Month'),
  },
  {
    type: PDatePickerFastChoice.FIRST_OF_THIS_MONTH,
    name: $t('This Month'),
  },
  {
    type: PDatePickerFastChoice.FIRST_OF_NEXT_MONTH,
    name: $t('Next Month'),
  },
  {
    type: PDatePickerFastChoice.FIRST_OF_LAST_YEAR,
    name: $t('Last Year'),
  },
  {
    type: PDatePickerFastChoice.FIRST_OF_THIS_YEAR,
    name: $t('This Year'),
  },
  {
    type: PDatePickerFastChoice.FIRST_OF_JANUARY,
    name: $t('January'),
  },
  {
    type: PDatePickerFastChoice.FIRST_OF_FEBRUARY,
    name: $t('February'),
  },
  {
    type: PDatePickerFastChoice.FIRST_OF_MARCH,
    name: $t('March'),
  },
  {
    type: PDatePickerFastChoice.FIRST_OF_APRIL,
    name: $t('April'),
  },
  {
    type: PDatePickerFastChoice.FIRST_OF_MAY,
    name: $t('May'),
  },
  {
    type: PDatePickerFastChoice.FIRST_OF_JUNE,
    name: $t('June'),
  },
  {
    type: PDatePickerFastChoice.FIRST_OF_JULY,
    name: $t('July'),
  },
  {
    type: PDatePickerFastChoice.FIRST_OF_AUGUST,
    name: $t('August'),
  },
  {
    type: PDatePickerFastChoice.FIRST_OF_SEPTEMBER,
    name: $t('September'),
  },
  {
    type: PDatePickerFastChoice.FIRST_OF_OCTOBER,
    name: $t('October'),
  },
  {
    type: PDatePickerFastChoice.FIRST_OF_NOVEMBER,
    name: $t('November'),
  },
  {
    type: PDatePickerFastChoice.FIRST_OF_DECEMBER,
    name: $t('December'),
  },
  {
    type: PDatePickerFastChoice.IN_A_WEEK,
    name: $t('In a Week'),
  },
  {
    type: PDatePickerFastChoice.IN_TWO_WEEKS,
    name: $t('In 2 Weeks'),
  },
  {
    type: PDatePickerFastChoice.IN_A_MONTH,
    name: $t('In a Month'),
  },
  {
    type: PDatePickerFastChoice.IN_HALF_A_YEAR,
    name: $t('In Half a Year'),
  },
  {
    type: PDatePickerFastChoice.IN_A_YEAR,
    name: $t('In a Year'),
  },
]
